export default __webpack_public_path__ + "static/media/readReviews@2x.2889cc38.png";